import { useEffect, useState } from "react";
import { getProduct, getCustomizerConfig } from "@/lib/api";

/* Capo di prova della home: t-shirt girocollo. Prodotto e config del
   configuratore caricati una volta sola e passati alle sezioni che li usano. */
export const TEE_SLUG = "t-shirt-unisex-girocollo";

export const useTeeData = () => {
  const [product, setProduct] = useState(null);
  const [config, setConfig] = useState(null);
  useEffect(() => {
    getProduct(TEE_SLUG).then(setProduct).catch(() => setProduct(null));
    getCustomizerConfig().then(setConfig).catch(() => setConfig(null));
  }, []);
  return { product, config };
};

export default useTeeData;
